<template>
  <img :src="logo" alt="Logo" />
</template>

<script>
export default {
  name: 'LogoSupport',
  data: () => ({
    logo: require(`assets/bitmaps/nina-logo.jpg`)
  })
}
</script>
<style lang="scss">
  .logo-img {
    display: block;
    //width: 132px;
    height: auto;
  }
</style>
